import { Modal, Text, ActionButton, Field, TextField } from 'components/commons';
import { useApi } from 'hooks';
import locale from 'localization';
import React, { useCallback, useContext, useState } from 'react';
import styles from './transaction-status-modal.module.scss';
import { capitalize, formatAmount, handleRequest } from 'utils';
import { updateTransactionStatus } from 'apis/transaction.api';
import { UserContext } from 'contexts';

const TransactionStatusModal = ({
  refetchTransactions,
  status,
  close,
  active,
  transactionId,
  customerAccountNumber,
  type,
  amount,
  productName,
  requestAction
}) => {
  const user = useContext(UserContext);
  const [reason, setReason] = useState();
  const [approverRemarks, setApproverRemarks] = useState();

  const { request: updateTransactionStatusRequest, loading: updatingTransaction } = useApi({
    api: updateTransactionStatus
  });

  const updateStatusCb = useCallback(async () => {
    console.log(status, user?.role);
    const newStatus = status;
    const newRequestAction = requestAction;

    // if (['approver', 'admin'].includes(user?.role)) {
    //   if (status === 'approve') {
    //     newStatus = 'success';
    //   } else if (status === 'reject') {
    //     newStatus = 'rejected';
    //   }
    // } else if (user?.role === 'maker') {
    //   if (status === 'voiding') {
    //     newStatus = 'voided';
    //     newRequestAction = 'voiding';
    //   }
    // }

    handleRequest(async () => {
      await updateTransactionStatusRequest(
        {
          transactionId,
          status: newStatus,
          reason,
          approverRemarks,
          requestAction: newRequestAction,
          userId: user?.userId
        },
        () => updateStatusCb()
      );
      refetchTransactions();
      close();
    });
  }, [
    status,
    user?.role,
    user?.userId,
    requestAction,
    updateTransactionStatusRequest,
    transactionId,
    reason,
    approverRemarks,
    refetchTransactions,
    close
  ]);

  let title = 'Void Transaction';
  let commandText = 'void';
  if (status === 'voiding') {
    title = 'Requesting to Void Transaction';
    commandText = 'void';
  } else if (status === 'approve') {
    title = 'Confirm to Approve Transaction';
    commandText = 'approve';
  } else if (status === 'reject') {
    title = 'Confirm to Reject Transaction';
    commandText = 'reject';
  }

  const customerAccountNumberText = requestAction
    ? `${customerAccountNumber} (${capitalize(requestAction)})`
    : customerAccountNumber;

  const voidText = (
    <locale.Populate
      text={locale.youAreAboutVoidTransaction}
      items={[
        commandText,
        <strong>{formatAmount(amount)}</strong>,
        <strong>{productName}</strong>,
        <strong>{type}</strong>,
        <strong>{customerAccountNumberText}</strong>
      ]}
    />
  );

  return (
    <Modal active={active} title={`${title}: ${transactionId}`} close={close} className={styles.modal}>
      <div className={styles.content}>
        <Text align="center">{voidText}</Text>
        {['maker', 'super-admin'].includes(user?.role) && (
          <Field label={'Reason'}>
            <TextField
              placeholder="Enter here..."
              value={reason}
              onChange={(name, { value }) => {
                setReason(value);
              }}
            />
          </Field>
        )}
        {['approver', 'admin', 'super-admin'].includes(user?.role) && (
          <Field label={'Approver Remarks'}>
            <TextField
              placeholder="Enter here..."
              value={approverRemarks}
              onChange={(name, { value }) => {
                setApproverRemarks(value);
              }}
            />
          </Field>
        )}
      </div>
      <ActionButton
        right
        items={[
          {
            text: locale.cancel,
            onClick: close
          },
          {
            loading: updatingTransaction,
            onClick: updateStatusCb,
            text: capitalize(commandText)
          }
        ]}
      />
    </Modal>
  );
};

export default TransactionStatusModal;
